import { Action, createReducer, on } from '@ngrx/store'
import { QueryState, initialQueriesashboardState } from '../state/query.state'
import {
  DELETE_QUERY_DETAILS,
  FETCH_QUERY_DETAILS_SUCCESS,
  fetch_query_dashboard_data_success,
  load_query_summary_success_action
} from '../action/query.action'
import { QueriesDashboardModel } from 'src/app/models/model'

export function queryReducer(state: QueryState, action: Action) {
  return _queryReducer(state, action)
}

const _queryReducer = createReducer(
  initialQueriesashboardState,
  on(fetch_query_dashboard_data_success, (state: any, { queriesItemsList, statusCountMap }) => {
    const dashboardData: QueriesDashboardModel = {
      queriesItemsList,
      statusCountMap
    }
    return {
      ...state,
      dashboard: dashboardData
    }
  }),
  on(FETCH_QUERY_DETAILS_SUCCESS, (state, { query }) => {
    return {
      ...state,
      details: query
    }
  }),
  on(DELETE_QUERY_DETAILS, (state, {}) => {
    return {
      ...state,
      details: null
    }
  }),
  on(load_query_summary_success_action, (state, { query }) => {
    return {
      ...state,
      summary: query
    }
  })
)
